export default __webpack_public_path__ + "static/media/statusAccepted.0312fe7d.png";